import { Action, Dispatch } from 'redux'
import { StoreDeliveryFeeType } from 'types/storeDeliveryFee'
import { confirmStoreDeliveryFeesAction } from 'reducks/storeDeliveryFee/actions'

const confirmStoreDeliveryFees = (storeDeliveryFees: StoreDeliveryFeeType[]) => {
  return async (dispatch: Dispatch<Action>) => {
    dispatch(confirmStoreDeliveryFeesAction(storeDeliveryFees))
  }
}

export default confirmStoreDeliveryFees
